/***
 *
 *   ANIMATE
 *   Wrapper component to animate in children
 *
 *   PROPS
 *   type: slideup, slidedown, pop (default: slideup)
 *   timeout: timeout (optional, default: 300)
 *   children: children to render
 *
 **********/

import { useRef, type ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import './animate.scss';

interface AnimateProps {
  type?: 'slideup' | 'slidedown' | 'pop' | 'pop-center';
  customClass?: string;
  timeout?: number;
  children?: ReactNode;
}

export function Animate(props: AnimateProps) {
  const type = props.type || 'slideup';
  const customClass = props.customClass || '';
  // React 19 removed ReactDOM.findDOMNode, which CSSTransition uses by default;
  // a nodeRef makes it target the child directly instead.
  const nodeRef = useRef(null);

  return (
    <CSSTransition in appear nodeRef={nodeRef} timeout={props.timeout || 300} classNames={`animate ${type}`}>
      <div ref={nodeRef} className={`animate onboarding-container ${type} ${customClass}`}>
        {props.children}
      </div>
    </CSSTransition>
  );
}
